import { useStyles } from './styles'
import { CaseScaledCard } from '@/shared/ui/caseScaledCard'
import { lang } from '@/shared/constants/lang'
import { OpenBoxButton } from '@/shared/ui/openBoxButton'
import { useUnit } from 'effector-react'
import { $userLanguage, $userToken, authUserFx } from '@/entities/user'
import { goToAuth, goToShop } from '@/app/routing/events'
import { getCaseContentFx, getCaseListFx, getUniqueContentFx } from '@/entities/cases'
import { $casesList, $lastViewedCaseId, $userKeys } from '@/entities/cases'
import { useEffect, useState } from 'react'
import { CaseOpeningConfirmation } from '@/shared/ui/caseOpeningConfirmation'
import { Spiner } from '@/shared/ui/spiner'
import Break from '@/shared/ui/break'
import { CaseIdToFolder, DescriptionTexts } from './types'
import { useBackButton } from '@/shared/hooks/useBackButton'
import { CaseKind } from '@/entities/cases'
import { UniqueCaseReward } from '@/features/uniqueCaseReward'
import { RewardList } from '@/features/rewardList'
import { useHideNav } from '@/shared/hooks/useHideNav'
import { $isBuyKeysModalVisible } from '@/entities/navigation/store'
import { useOpenCase } from '@/shared/hooks/useOpenCase'

export const ShopPageView = () => {
  useHideNav()
  const caseId = useUnit($lastViewedCaseId) ?? 1
  const userToken = useUnit($userToken)
  const userLang = useUnit($userLanguage)
  const userKeys = useUnit($userKeys)
  const caseList = useUnit($casesList)
  const isModalVisible = useUnit($isBuyKeysModalVisible)
  const caseKind = caseList?.find((_case) => _case.id == caseId)?.kind
  const { classes } = useStyles()
  const { handleOpenCase } = useOpenCase()
  const [isModalOpen, setIsModalOpen] = useState(false)
  const texts = lang[userLang].pages.boxPage
  const currentBox = caseList?.find((box) => box.id === caseId)
  const keys = currentBox?.price_keys
  const caseName = currentBox?.name
  const folder = caseName?.replace(/\s/g, '').toLowerCase()
  const isUniqueRewards = caseKind === CaseKind.UNIQUE
  const rewardPreviewTitle = isUniqueRewards ? texts.standardRewards : texts.widgetTexts.lootBoxScaled.withinCase

  const byKindSorting = ['Steam On! Case', 'PS 5 Limited Case']
  const sortStrategy = byKindSorting.includes(caseName!) ? 'byKind' : 'byAmount'

  useBackButton({ forceHide: isModalVisible })

  useEffect(() => {
    if (userToken == null) {
      authUserFx()
      return
    }
    getCaseListFx({ token: userToken! })
    getCaseContentFx({ token: userToken!, id: caseId })
    if (isUniqueRewards) {
      getUniqueContentFx({ token: userToken!, id: caseId })
    }
  }, [userToken, caseId, isUniqueRewards])

  const handleBoxButtonClick = async () => {
    if (!userToken) {
      goToAuth()
      return
    }
    if (!userKeys || userKeys! < currentBox!.price_keys!) {
      goToShop({ tab: 2 })
      return
    }

    setIsModalOpen(true)
  }

  const removeModalWindow = () => {
    setIsModalOpen(false)
  }

  // const mockForGiftCase = folder === 'telegramgiftcase'
  if (!caseList) return <Spiner variant="secondary" />

  return (
    <div className={classes.root} data-ismodalopen={isModalOpen}>
      <CaseScaledCard lootBoxId={caseId} />
      <OpenBoxButton onClick={handleBoxButtonClick} keys={keys!} />

      {isModalOpen && (
        <>
          <div className={classes.backdrop}></div>
          <div className={classes.keyModalWindowWrapper} id="key-modal-window">
            <CaseOpeningConfirmation
              caseName={caseName!}
              requiredKeys={keys!}
              onConfirm={handleOpenCase}
              onDeny={removeModalWindow}
            />
          </div>
        </>
      )}

      <div className={classes.expensiveWithHeadingnWrapper}>
        <UniqueCaseReward caseName={caseName!} />
        <span className={classes.expensiveText}>{rewardPreviewTitle}</span>
        <RewardList folder={folder!} sortStrategy={sortStrategy} mockForGiftCase={false} />
      </div>

      <Break />
      <div className={classes.description}>
        <h1>{texts.heading.description}</h1>
        {texts.descriptions[CaseIdToFolder[caseId] as keyof DescriptionTexts]}
      </div>
    </div>
  )
}
